import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { userProfile, getUsersList, userDetails, updatedAccountDetails, getUserCount, setDefaultAddress, accountActivation } from './userProfile.reducer';
import { alert } from './alert.reducer';
import { language } from './language.reducer';
import { uploadimage } from './uploadimage.reducer';
import { getCoupounList } from './coupon.reducer';
import { getTagsList, addTag, deleteTag, allActiveTags } from './tag.reducer';
import { getShopAndShopkeeperList, addShopAndShopkeeper, getShopkeeper, updateShopAndShopkeeperList } from './shop.reducer';
import { addCategory, getCategories, getCategory, getAllSubCategory, editCategory, getAllActiveCat, deleteCategory } from './category.reducer';
import { saveProduct, getProduct, getSingleProduct, updateSingleProduct, deleteProduct, getProductAttributes } from './product.reducer';
import { addTaxSettings, getTaxSettings, editTaxSettings, deleteTaxSettings } from './taxSettings.reducer';
import { addDiscount, getDiscountSettings, editDiscounts, deleteDiscount, activeDiscount } from './discount.reducer';
import { getPaymentTypesList } from './paymentTypes.reducer';
import { getNotificationsList, getUserNotificationsList, getUserBellNotificationsList, sentUserEmailNotifications } from './notification.reducer';
import { getBannersList, saveBanner, deleteBanner } from './banner.reducer';
import { getIdeasList, saveIdea, deleteIdea } from './idea.reducer';
import { getContestsList, saveContest, deleteContest } from './contest.reducer';
import { getSchoolsList, saveSchool, deleteSchool, getSchool, addSchool } from './school.reducer';
import { getGeneralSettings } from './setting.reducer';
import { getAllOrders, markOrder, markOrderAccepted } from './orders.reducer';
import { getAllOutlets } from './outlet.reducer';
import { getTrendingList, deleteTrending } from './trending.reducer';
import { getParticipantsList, saveParticipant, deleteParticipant, getParticipant, addParticipant } from './participant.reducer';


const rootReducer = combineReducers({
  authentication,
  userProfile, getUsersList, getUserCount, userDetails, setDefaultAddress, accountActivation,
  updatedAccountDetails, getCoupounList,
  alert, language,
  uploadimage,
  getShopAndShopkeeperList, addShopAndShopkeeper, getShopkeeper, updateShopAndShopkeeperList,
  addCategory, getCategories, getAllSubCategory, getCategory, editCategory, getAllActiveCat, deleteCategory,
  saveProduct, getProduct, getSingleProduct, updateSingleProduct, deleteProduct, getProductAttributes,
  addTaxSettings, getTaxSettings, editTaxSettings, deleteTaxSettings,
  addDiscount, getDiscountSettings, editDiscounts, deleteDiscount, activeDiscount,
  getTagsList, addTag, deleteTag, allActiveTags,
  getPaymentTypesList,
  getNotificationsList, getUserNotificationsList, getUserBellNotificationsList, sentUserEmailNotifications,
  getBannersList, saveBanner, deleteBanner,
  getIdeasList, saveIdea, deleteIdea,
  getContestsList, saveContest, deleteContest,
  getSchoolsList, saveSchool, deleteSchool, getSchool, addSchool,
  getGeneralSettings,
  getAllOrders, markOrder, markOrderAccepted,
  getAllOutlets,
  getTrendingList, deleteTrending,
  getParticipantsList, saveParticipant, deleteParticipant, getParticipant, addParticipant
});

export default rootReducer;
